<template>
<div id="app">
    <router-view />
</div>
</template>


<script>
import { setupOneSignal } from '@/services/oneSignal'
import {showIosInstallPrompt} from '@/services/pwa'
export default {
  name: "App-vue",
  computed: {
    admin() {
      return this.$store.getters.GET_USER_INFO
    }
  },
  watch: {
    admin: {
      immediate: true,
      async handler(value) {
        if (value?.id) {
          await setupOneSignal(value)
        }
      }
    }
  },
  mounted() {

    // showIosInstallPrompt(this)

  }
}
</script>

<style>
#sidebar-menu .menuitem-active .active {
  color: #000000 !important;
}

body {
  font-family: Quicksand,serif !important;
}
</style>
